import { sparklesExplosion } from "@/presentation/renderers/animations/sparklesExplosion.js";
import { scaleActionCard } from "@/presentation/prefabs/actor/actionCard/actionCardUtils.js";

/**
 * @param {Object} k - Kaplay instance
 * @param {Object} actionCard - Action card instance
 */
export function actionCardInteractions(k, actionCard) {

    const onHoverStart = () => {
        if (actionCard.isSpawning || actionCard.isCardSelected) return;

        scaleActionCard(k, actionCard, true);

        // Custom Cursor integration
        const cur = k.get("custom_cursor")[0];
        if (cur) cur.hoverCard();

        // Sparkle/Particle Effect
        sparklesExplosion(k, actionCard);
    };

    const onHoverEnd = () => {
        scaleActionCard(k, actionCard, actionCard.isCardSelected);

        const cur = k.get("custom_cursor")[0];
        if (cur) cur.clearHover();
    };

    // Input Listeners
    actionCard.onHover(onHoverStart);
    actionCard.onHoverEnd(onHoverEnd);
}